import React from "react";

interface ActionButtonsProps {
  fetchPositionLocation: () => void;
  onCalculateDistances: () => void;
  sendToEagle: () => void;
  distanceCalculated: boolean;
  isSendingToEagle: boolean;   // posting to eagle flag
  hasWorkshopSelected: boolean;  
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  fetchPositionLocation,
  onCalculateDistances,
  sendToEagle,
  distanceCalculated,
  isSendingToEagle,   // posting to eagle flag
  hasWorkshopSelected, 
}) => (
  <div
    style={{
      background: "#ffffff",
      border: "1px solid #d9d9d9",
      borderRadius: "8px",
      padding: "0.85rem 1rem",
      marginBottom: "1rem",
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      alignItems: "stretch",
    }}
  >
    <div style={{ display: "flex", gap: "0.5rem" }}>
      <button
        onClick={fetchPositionLocation}
        style={{
          padding: "6px 0",
          fontSize: "13px",
          borderRadius: "6px",
          backgroundColor: "#002663",
          color: "#fff",
          border: "1px solid #002663",
          cursor: "pointer",
          width: "50%",
          fontWeight: 700,
          transition: "background 0.2s",
          fontFamily: "Roboto, Arial, sans-serif",
          boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
        }}
      >
        Fetch location
      </button>
      <button
        onClick={onCalculateDistances}
        disabled={distanceCalculated}
        style={{
          padding: "6px 0",
          fontSize: "13px",
          borderRadius: "6px",
          backgroundColor: distanceCalculated ? "#e0e0e0" : "#ffe066",
          color: distanceCalculated ? "#888" : "#002663",
          border: distanceCalculated ? "1px solid #e0e0e0" : "1px solid #ffe066",
          cursor: distanceCalculated ? "not-allowed" : "pointer",
          width: "50%",
          fontWeight: 700,
          transition: "background 0.2s",
          fontFamily: "Roboto, Arial, sans-serif",
          boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
        }}
      >
        Calculate Distance
      </button>
    </div>
    <button
      onClick={sendToEagle}
      disabled={isSendingToEagle}        // posting to eagle is true , disable button
      style={{
        padding: "6px 0",
        fontSize: "13px",
        borderRadius: "6px",
        backgroundColor: isSendingToEagle ? "#7a8ca8" : "#002663",
        color: "#fff",
        border: "1px solid #002663",
        cursor: isSendingToEagle ? "not-allowed" : "pointer",  
        width: "100%",
        fontWeight: 700,
        marginTop: "0.25rem",
        transition: "background 0.2s",
        fontFamily: "Roboto, Arial, sans-serif",
        boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
        opacity: isSendingToEagle ? 0.6 : 1,            
      }}
    >
      {isSendingToEagle
  ? "Sending…"
  : hasWorkshopSelected
    ? "Draw Route & Send to Eagle"
    : "Send Breakdown Location"}
    </button>
  </div>
);

export default ActionButtons;
